const modifyGrid = (data) => data

export default modifyGrid
